import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import { getPageProps } from "@services/initial-calls";
import TermsAndConditions from "@components/shared/legal/termsAndConditions";
import BusinessCopyMachinesWrapper from "@components/layouts/businessCopyMachines";

export default function BuyYourMachineHome(): ReactElement {
    return (
        <BusinessCopyMachinesWrapper>
            <TermsAndConditions
                category="BusinessCopyMachines"
                domain="BusinessCopyMachines.com"
            />
        </BusinessCopyMachinesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", {
        pageTitle: "Terms And Conditions",
    });
};
